import WinBase from "./winBase";
import GoAclDialog from "../../goAclDialog";
import {GoingUtils} from "goingutils";

class ShowAclWin extends WinBase {
    constructor(options) {
        super(options);
        this.options = {};
        //如果界面是大屏 采用660的高度 如果是小屏幕则根据屏幕进行计算
        let bodyHeight=$(document.body).height();
        let winHeight=bodyHeight>660?660:(bodyHeight-10);
        let defConfig = {height: winHeight};
        this.options = $.extend(defConfig, options);
    }

    /**
     * 激活授权窗口
     * @param vueObj
     * @returns {*}
     */
    showWin(vueObj) {
        let aclWinObj = this;
        let divId = GoingUtils.getUUid(10);
        let htmlContent =
            "<div id='" + divId + "' style='width: 100%;height:100%;'></div>";
        //弹出窗口
        aclWinObj.showDialogWin(htmlContent,this.options["closeWin"]);
        //初始化容器的高度
        aclWinObj.initWinContainer(divId);
        //弹出授权窗口
        let goAclWin = new GoAclDialog(divId, aclWinObj.options, vueObj);
        //初始化底部操作栏
        aclWinObj.addBottomBar(divId);
        //初始化底部事件
        aclWinObj.initBottomEvent({divId, goAclWin, vueObj,closeWin:this.options["closeWin"]});
        return goAclWin;
    }
}
export default ShowAclWin;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/components/showAclWin.js